import { Component } from '@theme/component';
import { CartLinesUpdateEvent } from '@shopify/events';

class EWAddons extends Component {
  busy = false;
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('submit', this.submit);
    this.addEventListener('change', this.change);
    this.addEventListener('click', this.click);
    this.querySelectorAll('[data-enhanced]').forEach(el => el.hidden = false);
    this.refresh();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('submit', this.submit);
    this.removeEventListener('change', this.change);
    this.removeEventListener('click', this.click);
  }
  change = () => this.refresh();
  refresh() {
    let total = 0, count = 0, invalid = false;
    this.querySelectorAll('form[data-addon]').forEach(form => {
      const choice = form.elements.namedItem('id');
      const option = choice.selectedOptions?.[0];
      const valid = Boolean(choice.value);
      const price = option?.dataset.money || choice.dataset.money;
      const display = form.querySelector('[data-price]');
      if (price && display) display.textContent = price;
      form.querySelector('button[type="submit"]').disabled = this.busy || !valid;
      if (form.querySelector('[data-include]')?.checked) {
        count++;
        invalid ||= !valid;
        total += Number(option?.dataset.price || choice.dataset.price || 0);
      }
    });
    const batch = this.querySelector('[data-add-selected]');
    if (batch) batch.disabled = this.busy || !count || invalid;
    const output = this.querySelector('[data-total]');
    if (output) output.textContent = count && !invalid ? new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency}).format(total / 100) : '';
  }
  submit = event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-addon]')) return;
    event.preventDefault();
    if (!form.reportValidity() || this.busy) return;
    this.add([{id:form.elements.namedItem('id').value,quantity:1}], event.submitter);
  };
  click = event => {
    const button = event.target.closest('[data-add-selected]');
    if (!button || this.busy) return;
    const forms = [...this.querySelectorAll('form[data-addon]')].filter(f => f.querySelector('[data-include]')?.checked);
    if (!forms.length || forms.some(f => !f.reportValidity())) return;
    this.add(forms.map(f => ({id:f.elements.namedItem('id').value,quantity:1})), button);
  };
  async add(items, trigger) {
    this.busy = true;
    this.setAttribute('aria-busy','true');
    const status = this.querySelector('[data-status]');
    status.textContent = this.dataset.adding;
    this.refresh();
    const pending = CartLinesUpdateEvent.createPromise();
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:this.dataset.context === 'cart' ? 'cart' : 'product',lines:items.map(i=>({merchandiseId:i.id,quantity:i.quantity})),promise:pending.promise}));
    let added = false;
    try {
      const response = await fetch(Theme.routes.cart_add_url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sections.join(','),sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
      added = true;
      const cartResponse = await fetch(Theme.routes.cart_url + '.js',{headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error(this.dataset.error);
      const cart = await cartResponse.json();
      pending.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,itemCount:cart.item_count,sections:result.sections,source:'ew-addons',didError:false}});
      status.textContent = this.dataset.added;
      this.querySelectorAll('[data-include]').forEach(el=>el.checked=false);
    } catch(error) {
      pending.reject(error);
      status.textContent = added ? this.dataset.checkCart : (error.message || this.dataset.error);
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.refresh();
    }
  }
}
if (!customElements.get('ew-addons')) customElements.define('ew-addons',EWAddons);
